/**
 * La Europea — Mobile Menu Slide Navigation
 * Converts accordion drawer menu into level-based slide navigation.
 * Supports arbitrary depth (3 levels: parent → child → grandchild).
 * Only runs on mobile (<750px). Desktop is untouched.
 */
(function() {
  if (window.innerWidth >= 750) return;

  var BACK_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18l-6-6 6-6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FWD_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var menuList = null;
  var nav = null;
  var panelStack = []; // {panel, parentLayer}

  function init() {
    menuList = document.querySelector('.menu-drawer__menu.has-submenu');
    nav = document.querySelector('.menu-drawer__navigation');
    if (!menuList || !nav) {
      setTimeout(init, 300);
      return;
    }

    var allItems = menuList.querySelectorAll(':scope > li');
    allItems.forEach(function(li) {
      if (!hasChildren(li)) return;
      var details = li.querySelector('details');
      var clickTarget = details ? details.querySelector('summary') : li.querySelector('.menu-drawer__menu-item--mainlist');
      if (!clickTarget) return;
      if (clickTarget.dataset.leBound === '1') return;
      clickTarget.dataset.leBound = '1';

      // Capture-phase + stopImmediatePropagation to block Horizon's
      // on:click="header-drawer/open" Theme Studio handler that otherwise
      // slides in the native nested submenu and covers our custom panel.
      clickTarget.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        // Defensive: make sure the native <details> doesn't end up open
        if (details && details.open) details.open = false;
        openSubmenuPanel(li, menuList);
      }, true);
    });
  }

  // True if this <li> has any nested submenu (childlist OR grandchildlist).
  function hasChildren(li) {
    return !!li.querySelector('.menu-drawer__menu--childlist, .menu-drawer__menu--grandchildlist');
  }

  // Find the direct children <li>s of a given source <li>.
  // For level-1 sources: there is a .menu-drawer__menu--childlist nested inside —
  //   AND deeper inside, a .menu-drawer__menu--grandchildlist. Prefer childlist first.
  // For level-2 sources: only .menu-drawer__menu--grandchildlist exists inside.
  function getChildItems(sourceLi) {
    var childList = sourceLi.querySelector('.menu-drawer__menu--childlist')
                 || sourceLi.querySelector('.menu-drawer__menu--grandchildlist');
    if (!childList) return [];
    return childList.querySelectorAll(':scope > li');
  }

  function getTitle(sourceLi) {
    // Prefer summary text (collapsible parents), fall back to first link text
    var summary = sourceLi.querySelector(':scope > details > summary, :scope > accordion-custom > details > summary');
    if (summary) {
      var txt = summary.querySelector('.menu-drawer__menu-item-text');
      if (txt) return txt.textContent.trim();
      return summary.textContent.trim();
    }
    var a = sourceLi.querySelector(':scope > a');
    if (a) {
      var t = a.querySelector('.menu-drawer__menu-item-text');
      if (t) return t.textContent.trim();
      return a.textContent.trim();
    }
    return '';
  }

  // Resolve a URL for "Ver todo" of a source <li>.
  // 1) data-link-url on level-1 <li> (rendered by Liquid).
  // 2) Direct <a> child (flat 3-level menus put the parent link as a sibling of the grandchildlist).
  // 3) <a> nested inside summary (accordion case, rare).
  function getSourceUrl(sourceLi) {
    if (sourceLi.dataset && sourceLi.dataset.linkUrl) return sourceLi.dataset.linkUrl;
    var directA = sourceLi.querySelector(':scope > a');
    if (directA && directA.href) return directA.href;
    var summaryA = sourceLi.querySelector(':scope > details > summary a, :scope > accordion-custom > details > summary a');
    if (summaryA && summaryA.href) return summaryA.href;
    return '';
  }

  function openSubmenuPanel(sourceLi, parentLayer) {
    var title = getTitle(sourceLi);
    var childLis = getChildItems(sourceLi);

    var panel = document.createElement('div');
    panel.className = 'le-menu-level2';

    // Back button
    var backBtn = document.createElement('button');
    backBtn.className = 'le-menu-back';
    backBtn.type = 'button';
    backBtn.innerHTML = BACK_SVG;
    backBtn.addEventListener('click', function() {
      closePanel(panel, parentLayer);
    });
    panel.appendChild(backBtn);

    // Children list
    var linksList = document.createElement('ul');
    linksList.className = 'le-menu-level2__links';

    childLis.forEach(function(childLi) {
      var childHasChildren = hasChildren(childLi);
      var label = '';
      var href = '#';

      if (childHasChildren) {
        // First .menu-drawer__menu-item-text in DOM order is the parent's label
        // (works for both accordion <summary> and flat <a> structures).
        var txtEl = childLi.querySelector('.menu-drawer__menu-item-text');
        label = (txtEl && txtEl.textContent.trim()) || '';
        href = getSourceUrl(childLi) || '#';
      } else {
        var a = childLi.querySelector('a');
        if (!a) return;
        var aTxt = a.querySelector('.menu-drawer__menu-item-text');
        label = (aTxt && aTxt.textContent.trim()) || a.textContent.trim();
        href = a.href;
      }

      var newLi = document.createElement('li');
      var newA = document.createElement('a');
      newA.className = 'le-menu-level2__link';
      newA.href = href;
      newA.textContent = label;
      if (childHasChildren) newA.innerHTML += FWD_SVG;

      if (childHasChildren) {
        newA.addEventListener('click', function(e) {
          e.preventDefault();
          openSubmenuPanel(childLi, panel);
        });
      }

      newLi.appendChild(newA);
      linksList.appendChild(newLi);
    });

    // "Ver Todo" to the parent category URL
    var parentUrl = getSourceUrl(sourceLi);
    if (parentUrl && parentUrl !== '#') {
      var viewAllLi = document.createElement('li');
      viewAllLi.className = 'le-menu-level2__view-all-item';
      var viewAllA = document.createElement('a');
      viewAllA.className = 'le-menu-level2__view-all';
      viewAllA.href = parentUrl;
      viewAllA.textContent = 'Ver Todo';
      viewAllLi.appendChild(viewAllA);
      linksList.appendChild(viewAllLi);
    }

    panel.appendChild(linksList);

    // Promo cards only when opening from the root menu (level 1 → level 2).
    if (parentLayer === menuList) {
      appendPromoCards(panel, sourceLi, title);
    }

    nav.appendChild(panel);

    var drawer = nav.closest('.menu-drawer') || nav.closest('[data-header-drawer]');
    if (drawer) drawer.classList.add('le-menu-l2-open');

    requestAnimationFrame(function() {
      if (parentLayer === menuList) {
        menuList.classList.add('le-menu-l1--hidden');
      }
      panel.classList.add('le-menu-level2--active');
    });

    panelStack.push({ panel: panel, parentLayer: parentLayer });
  }

  function closePanel(panel, parentLayer) {
    panel.classList.remove('le-menu-level2--active');

    if (parentLayer === menuList) {
      menuList.classList.remove('le-menu-l1--hidden');
    }

    setTimeout(function() {
      panel.remove();
    }, 350);

    // Pop this panel from the stack
    panelStack = panelStack.filter(function(p) { return p.panel !== panel; });

    if (panelStack.length === 0) {
      var drawer = nav.closest('.menu-drawer') || nav.closest('[data-header-drawer]');
      if (drawer) drawer.classList.remove('le-menu-l2-open');
    }
  }

  function appendPromoCards(panel, sourceLi, title) {
    var promoImages = sourceLi.querySelectorAll('.menu-drawer__link-image, .mega-menu__media img, .link-featured-image');
    if (promoImages.length > 0) {
      var promosDiv = document.createElement('div');
      promosDiv.className = 'le-menu-level2__promos';
      var count = 0;
      promoImages.forEach(function(img) {
        if (count >= 2) return;
        var parentA = img.closest('a');
        var promoLink = document.createElement('a');
        promoLink.className = 'le-menu-level2__promo';
        promoLink.href = parentA ? parentA.href : '#';

        var promoImg = document.createElement('img');
        promoImg.className = 'le-menu-level2__promo-img';
        promoImg.src = img.src || (img.querySelector && img.querySelector('img') && img.querySelector('img').src) || '';
        promoImg.alt = '';
        promoImg.loading = 'lazy';

        var promoName = document.createElement('span');
        promoName.className = 'le-menu-level2__promo-name';
        var pTxt = parentA && parentA.querySelector('.menu-drawer__menu-item-text');
        promoName.textContent = (pTxt && pTxt.textContent.trim()) || '';

        var promoDiscover = document.createElement('span');
        promoDiscover.className = 'le-menu-level2__promo-link';
        promoDiscover.textContent = 'Descubrir';

        promoLink.appendChild(promoImg);
        promoLink.appendChild(promoName);
        promoLink.appendChild(promoDiscover);
        promosDiv.appendChild(promoLink);
        count++;
      });
      if (count > 0) panel.appendChild(promosDiv);
    }

    // Clone desktop mega-menu promo cards if names match
    var parentText = (title || '').toLowerCase().trim();
    var allMegaMenus = document.querySelectorAll('.mega-menu');
    allMegaMenus.forEach(function(mm) {
      var li = mm.closest('li');
      var menuLink = li && li.querySelector('.mega-menu__link, .header-menu__link');
      var menuText = (menuLink && menuLink.textContent.trim().toLowerCase()) || '';
      if (parentText && (menuText.includes(parentText) || parentText.includes(menuText))) {
        var promoCards = mm.querySelector('.le-mega-promo-cards');
        if (promoCards) {
          var cloned = promoCards.cloneNode(true);
          cloned.style.display = 'flex';
          cloned.style.gap = '16px';
          cloned.style.marginTop = '24px';
          panel.appendChild(cloned);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.header__icon--menu')) {
      setTimeout(init, 100);
    }
  });
})();
